import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CITIES = [
  "Sacramento", "Roseville", "Folsom", "Elk Grove", "Davis",
  "Citrus Heights", "Rocklin", "Woodland", "Rancho Cordova",
  "Lincoln", "Auburn", "Carmichael", "Granite Bay", "Fair Oaks", "Loomis",
];

export const SERVICE_LABELS = {
  home_inspection: "Home Inspection",
  pest_control: "Pest Control",
  roofing: "Roofing",
  hvac: "HVAC",
  general_contractor: "General Contractor",
  residential_inspection: "Residential Inspections",
  commercial_inspection: "Commercial Inspections",
  termite_pest_inspection: "Termite & Pest Inspections",
  roof_inspection: "Roof Inspections",
  mold_environmental: "Mold & Environmental Testing",
  sewer_septic: "Sewer & Septic Inspections",
  foundation_structural: "Foundation & Structural Inspections",
  pool_spa: "Pool & Spa Inspections",
  electrical_hvac_inspection: "Electrical & HVAC Inspections",
  insurance_inspection: "Insurance Property Inspections",
  appraisal: "Appraisals",
  insurance_agent: "Insurance Agent",
  real_estate_agent: "Real Estate Agent",
  both: "Inspection & Pest",
};
export const SERVICE_BADGES = {
  home_inspection: "badge-ins",
  pest_control: "badge-pest",
  roofing: "badge-roof",
  hvac: "badge-hvac",
  general_contractor: "badge-gc",
  insurance_agent: "badge-hvac",
  real_estate_agent: "badge-roof",
  both: "badge-ins",
};
export const serviceLabel = (k) => SERVICE_LABELS[k] || (k ? k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : k);
export const serviceBadge = (k) => SERVICE_BADGES[k] || "badge-ins";

export const PLANS = [
  { key: "sub_starter_monthly", name: "Starter", price: 99, credits: 10, tier: "starter",
    features: ["10 lead credits / month", "Directory listing", "Verified badge", "Email support"] },
  { key: "sub_pro_monthly", name: "Pro", price: 199, credits: 25, tier: "pro", popular: true,
    features: ["25 lead credits / month", "Featured placement", "Priority lead matching", "Analytics dashboard", "Phone support"] },
  { key: "sub_elite_monthly", name: "Elite", price: 349, credits: 60, tier: "elite",
    features: ["60 lead credits / month", "Top featured placement", "Instant lead alerts", "Dedicated account manager", "Full analytics suite"] },
];

export const FOUNDING = {
  key: "sub_founding_monthly",
  name: "Founding Member",
  price: 15,
  credits: 50,
  tier: "founding",
  features: [
    "First 60 days FREE for early pros",
    "50 lead credits / month — all trades",
    "Verified badge & directory listing",
    "Rate locked for 12 months",
    "Cancel anytime, no contract",
  ],
};

export const AGENT_CATEGORIES = [
  { key: "insurance_agent", label: "Insurance Agent" },
  { key: "real_estate_agent", label: "Real Estate Agent" },
];
export const isAgent = (cat) => AGENT_CATEGORIES.some((a) => a.key === cat);

export const AGENT_PLAN = {
  key: "sub_agent_monthly",
  name: "Agent Partner",
  price: 7,
  tier: "agent_partner",
  features: [
    "First 60 days FREE",
    "Profile in the Agents directory",
    "Verified badge & reviews",
    "Referral visibility with local homeowners",
    "Cancel anytime, no contract",
  ],
};

export const CREDIT_PACKS = [
  { key: "credits_1", credits: 1, price: 10 },
  { key: "credits_5", credits: 5, price: 75 },
  { key: "credits_10", credits: 10, price: 140, save: "7%" },
  { key: "credits_25", credits: 25, price: 325, save: "13%" },
];
